import api from "../utils/axiosConfig";

export interface Bank {
  code: string;
  name: string;
}

export interface BankListApiResponse {
  status: number;
  system: string;
  message: string;
  data: Bank[];
}

/**
 * The banks the signup form offers.
 *
 * Read from the API rather than from a file bundled with this app. The console
 * offers the identical list when an operator creates a player or corrects a
 * registration, and a list that ships inside one of the two clients is a list
 * the other cannot see — so the field on a registration and the field used to
 * fix it could offer different banks.
 *
 * The envelope is kept as the form already expects it; only where the rows come
 * from has changed.
 */
export const getBankList = async (): Promise<BankListApiResponse> => {
  const response = await api.get<{ items: Bank[] }>("/banks");
  return {
    status: 1,
    system: "bank",
    message: "Bank list retrieved successfully",
    data: response.data.items,
  };
};
